import { Component, Vue } from 'vue-property-decorator';
import { HRMRecord } from '@/models/assessment-period';
import { fetchHRMRecords } from '@/services/home';

interface GroupedHRMRecords {
  [periodId: number]: {
    periodName: string;
    records: {
      activityName: string;
      totalHours: number;
      message: string;
    }[];
  };
}

@Component({
  name: 'MyRecord',
  components: {}
})
export default class MyRecord extends Vue {
  private records: HRMRecord[] = [];
  private loading = true;
  private error: string | null = null;
  
  private headers = [
    { text: 'Project/Activities', value: 'activityName' },
    { text: 'Total Hours - Successfully Recorded', value: 'totalHours', align: 'end' },
    { text: 'Message from PM (if any)', value: 'message' }
  ];

  get groupedRecords(): GroupedHRMRecords {
    return this.records.reduce((acc: GroupedHRMRecords, record) => {
      if (!acc[record.periodId]) {
        acc[record.periodId] = {
          periodName: record.periodName,
          records: []
        };
      }
      
      acc[record.periodId].records.push({
        activityName: record.activityName,
        totalHours: record.totalHours,
        message: record.message || 'N/A'
      });
      
      return acc;
    }, {});
  }

  get sortedPeriods(): string[] {
    return Object.keys(this.groupedRecords)
      .sort((a, b) => parseInt(b) - parseInt(a)); // Sort by periodId in descending order
  }

  async created(): Promise<void> {
    try {
      const { data } = await fetchHRMRecords();
      this.records = data;
    } catch (error) {
      this.error = 'Failed to load HRM records. Please try again later.';
      console.error('Error fetching HRM records:', error);
    } finally {
      this.loading = false;
    }
  }
}
